import gql from 'graphql-tag'

export const CREATE_DEPARTMENT = gql`
  mutation ($data: DepartmentCreateInput) {
    createDepartment(data: $data) {
      id
      departmentName
      head {
        id
        firstName
        lastName
      }
    }
  }
`

export const UPDATE_DEPARTMENT = gql`
  mutation ($id: ID!, $data: DepartmentUpdateInput) {
    updateDepartment(id: $id, data: $data) {
      id
      departmentName
      head {
        id
        firstName
        lastName
      }
    }
  }
`

export const DELETE_DEPARTMENT = gql`
  mutation ($id: ID!) {
    deleteDepartment(id: $id)
  }
`

export const CREATE_TEAM = gql`
  mutation ($data: TeamCreateInput) {
    createTeam(data: $data) {
      id
      departmentId
      teamName
      teamLeaderId
      # currentLoadScore
    }
  }
`

export const UPDATE_TEAM = gql`
  mutation ($id: ID!, $data: TeamUpdateInput) {
    updateTeam(id: $id, data: $data) {
      id
      departmentId
      teamName
      teamLeaderId
      # currentLoadScore
    }
  }
`

export const DELETE_TEAM = gql`
  mutation ($id: ID!) {
    deleteTeam(id: $id)
  }
`

export const ADD_CHAT_PARTICIPANT = gql`
  mutation ($chatRoomId: ID!, $userId: ID!) {
    addChatParticipant(chatRoomId: $chatRoomId, userId: $userId)
  }
`

export const DELETE_CHAT_PARTICIPANT = gql`
  mutation ($chatRoomId: ID!, $userId: ID!) {
    deleteChatParticipant(chatRoomId: $chatRoomId, userId: $userId)
  }
`
export const CREATE_TEAM_MEMBER = gql`
  mutation ($data: TeamMemberCreateInput) {
    createTeamMember(data: $data) {
      id
      teamId
      userId
      specialization
      isAvailable
      ticketLoad
      maxTicketLoad
    }
  }
`

export const UPDATE_TEAM_MEMBER = gql`
  mutation ($id: ID!, $data: TeamMemberUpdateInput) {
    updateTeamMember(id: $id, data: $data) {
      id
      teamId
      userId
      specialization
      isAvailable
      ticketLoad
      maxTicketLoad
    }
  }
`

export const DELETE_TEAM_MEMBER = gql`
  mutation ($id: ID!) {
    deleteTeamMember(id: $id)
  }
`

export const CREATE_ESCALATION_RULE = gql`
  mutation ($data: EscalationRuleCreateInput) {
    createEscalationRule(data: $data) {
      id
    }
  }
`

export const UPDATE_ESCALATION_RULE = gql`
  mutation ($id: ID!, $data: EscalationRuleUpdateInput) {
    updateEscalationRule(id: $id, data: $data) {
      id
    }
  }
`

export const DELETE_ESCALATION_RULE = gql`
  mutation ($id: ID!) {
    deleteEscalationRule(id: $id)
  }
`

export const CREATE_KEYWORD_MAPPING = gql`
  mutation ($data: KeywordMappingCreateInput) {
    createKeywordMapping(data: $data) {
      id
      keyword
      departmentId
      teamId
      suggestsPriority {
        id
        priorityLevel
        slaTime
      }
      isActive
      department {
        id
        departmentName
      }
      team {
        id
        teamName
      }
    }
  }
`

export const UPDATE_KEYWORD_MAPPING = gql`
  mutation ($id: ID!, $data: KeywordMappingUpdateInput) {
    updateKeywordMapping(id: $id, data: $data) {
      id
      keyword
      departmentId
      teamId
      suggestsPriority {
        id
        priorityLevel
        slaTime
      }
      isActive
      department {
        id
        departmentName
      }
      team {
        id
        teamName
      }
    }
  }
`

export const DELETE_KEYWORD_MAPPING = gql`
  mutation ($id: ID!) {
    deleteKeywordMapping(id: $id)
  }
`

export const CREATE_AVAILABILITY_LOG = gql`
  mutation CreateTeamMemberAvailabilityLog(
    $input: CreateTeamMemberAvailabilityLogInput!
  ) {
    createTeamMemberAvailabilityLog(input: $input) {
      id
    }
  }
`

export const UPDATE_AVAILABILITY_LOG = gql`
  mutation UpdateAvailabilityLog($id: ID!, $data: UpdateAvailabilityLogInput!) {
    updateAvailabilityLog(id: $id, data: $data) {
      id
      reason
      updatedAt
    }
  }
`

export const CREATE_PRIORITY_SLA_CONFIG = gql`
  mutation CreatePrioritySlaConfig($data: CreatePrioritySlaConfigInput!) {
    createPrioritySlaConfig(data: $data) {
      id
    }
  }
`

export const UPDATE_PRIORITY_SLA_CONFIG = gql`
  mutation UpdatePrioritySlaConfig(
    $id: ID!
    $data: UpdatePrioritySlaConfigInput!
  ) {
    updatePrioritySlaConfig(id: $id, data: $data) {
      id
    }
  }
`

export const DELETE_PRIORITY_SLA_CONFIG = gql`
  mutation ($id: ID!) {
    deletePrioritySlaConfig(id: $id)
  }
`
